<p>vh-sale-stats works!</p>
